import { RootState } from "../../../store";

export const widgetSelectorStateSelector = (state: RootState) =>
  state.dashboards.widgetSelectorState;
